import { memo } from "react";
import { arrayOf, bool, number, object, shape, string } from "prop-types";
import { parsePrice, roundFloat } from "@repo/utils";
import { Grid } from "@material-ui/core";

export const BillingChartBarTooltipContent = memo(({
  values,
  currencyObj,
  roundPrice,
  americanFormat,
}) => (
  <Grid item container direction="column" className="font-bold">
    {
      values
        .filter(v => v.value)
        .map(({name, value}) => (
          <span key={name}>
            {name}{": "}
            {currencyObj.symbolStart || ""}
            {parsePrice(roundFloat(value, roundPrice ? 3 : 0, !roundPrice), americanFormat)}
            {currencyObj.symbolEnd || ""}
          </span>
        ))
    }
  </Grid>
));

BillingChartBarTooltipContent.propTypes = {
  currencyObj: object,
  roundPrice: bool,
  americanFormat: bool,
  values: arrayOf(shape({
    value: number.isRequired,
    hours: number.isRequired,
    name: string.isRequired,
    color: string,
  })),
};